<template>
  <div id="load-external-js">
  </div>
</template>

<script>
/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
export default {
  props: ['url'],
  created() {
    let tag_name = 'script';
    let recaptchaScript = document.createElement(tag_name);
    recaptchaScript.setAttribute('type', "text/javascript");
    recaptchaScript.setAttribute('src', this.url);
    document.head.appendChild(recaptchaScript);
  }
}
</script>